<div class="llm-actions-container">
  @if (isCopyForLLMButton) {
      <wpbutton
        (click)="copyLLMContent()"
        class="-outline"
        [disabled]="isLoadingCopy || isCopied || !llmFilePath"
        [attr.aria-busy]="isLoadingCopy || isCopied"
        title="Copy LLM content to clipboard">
        @if (!isLoadingCopy && !isCopied) {
          <span>Copy for LLM</span>
        }
        @if (isCopied) {
          <span>Copied!</span>
        }
        @if (isLoadingCopy) {
          <span>Copying...</span>
        }
      </wpbutton>
  }
  @if (isViewAsMarkdownButton) {
    <wpbutton
      (click)="viewMarkdown()"
      class="-outline"
      [disabled]="isLoadingView || !markdownFilePath"
      [attr.aria-busy]="isLoadingView"
      title="View Markdown file in new window">
      @if (!isLoadingView) { 
        <span>View as Markdown</span>
        <icon icon="external-link" class="-xsm"></icon>
      }
      @if (isLoadingView) { 
        <span>Opening...</span>
      }
    </wpbutton>
  }
</div>

@if(showMessage) {
  <div class="llm-actions-message-container">
    <app-notification
      [tone]="getNotificationTone()"
      [title]="getNotificationTitle()"
      (dismissAction)="dismissMessage()">
      {{ message }}
    </app-notification>
  </div>
}

